// Comment highlight colours (MS-Word-style per-author). `hl` = soft rgba painted over the text
// in the document; `hlStrong` = the same hue at full strength, used when a comment is clicked
// (so the emphasized passage keeps its author's colour instead of turning a generic amber);
// `sw` = solid swatch used for the legend + the card's author badge.
//
// Shared by ProTrack's own project documents and by a product's room documents, because they are
// meant to be one experience — the moment these lived in two places they started to drift.
export const DOC_SELF_COLOR = { hl: 'rgba(255,235,59,.5)', hlStrong: 'rgba(250,204,21,.9)', sw: '#f59e0b' }  // my own comments — always yellow
export const DOC_OTHER_COLORS = [
  { hl: 'rgba(129,199,132,.5)', hlStrong: 'rgba(102,187,106,.9)', sw: '#43a047' },
  { hl: 'rgba(100,181,246,.5)', hlStrong: 'rgba(66,165,245,.9)', sw: '#1e88e5' },
  { hl: 'rgba(240,98,146,.45)', hlStrong: 'rgba(236,64,122,.85)', sw: '#e91e63' },
  { hl: 'rgba(186,104,200,.45)', hlStrong: 'rgba(171,71,188,.85)', sw: '#8e24aa' },
  { hl: 'rgba(255,167,38,.5)', hlStrong: 'rgba(251,140,0,.9)', sw: '#fb8c00' },
  { hl: 'rgba(77,208,225,.45)', hlStrong: 'rgba(38,198,218,.85)', sw: '#00acc1' },
]

export const initialsOf = (name) =>
  (name || '—').split(/\s+/).map(w => w[0] || '').join('').slice(0, 2).toUpperCase()

/**
 * Work out who gets which colour in one document's thread, and everything the viewer needs to
 * paint it: the passages to highlight, the palette keyed the way FileViewerModal expects, and
 * the legend.
 *
 * Only anchored comments — those quoting a passage — are highlighted; a comment about the whole
 * file has nothing to point at.
 */
export function commentColors(all, myUserId) {
  const anchored = (all || []).filter(c => c.quoted_text)
  const isSelf = (c) => c.user_id != null && c.user_id === myUserId
  const keyOf = (c) => (c.user_id != null ? 'u' + c.user_id : 'n:' + c.user_name)

  const others = []
  anchored.forEach(c => { if (!isSelf(c)) { const k = keyOf(c); if (!others.includes(k)) others.push(k) } })

  const colorKeyOf = (c) => (isSelf(c) ? 'self' : 'a' + others.indexOf(keyOf(c)))
  const colorOf = (c) => (isSelf(c) ? DOC_SELF_COLOR
    : DOC_OTHER_COLORS[others.indexOf(keyOf(c)) % DOC_OTHER_COLORS.length])

  const palette = { self: DOC_SELF_COLOR.hl }
  others.forEach((k, i) => { palette['a' + i] = DOC_OTHER_COLORS[i % DOC_OTHER_COLORS.length].hl })

  const highlights = anchored.map(c => ({ id: c.id, text: c.quoted_text, colorKey: colorKeyOf(c) }))

  const legend = []
  if (anchored.some(isSelf)) legend.push({ label: 'You', sw: DOC_SELF_COLOR.sw })
  others.forEach((k, i) => legend.push({
    label: anchored.find(c => keyOf(c) === k)?.user_name || '—',
    sw: DOC_OTHER_COLORS[i % DOC_OTHER_COLORS.length].sw,
  }))

  return { anchored, isSelf, colorOf, colorKeyOf, palette, highlights, legend }
}
